export default __webpack_public_path__ + "static/media/phone_preview.1bbc6ef3.png";